<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SrujTB/tc-custom/9781683500643.jpg?1718170132834" alt="This image is the cover for the book It's Not About You, Mr. Easter Bunny, The Love Letters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">It's Not About You, Mr. Easter Bunny, The Love Letters
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Hop into the ancient origins of the Easter holiday, its religious significance, and the rich symbolism behind the candy, decorated eggs, and chicks.</b><br/>  <br/> Easter is a favorite holiday for children around the world. Chocolate bunnies, stuffed rabbits, colored eggs, and fuzzy baby chicks fill Easter baskets as children eagerly anticipate the traditional Easter egg hunt and the Easter Bunny.<br/>  <br/> Have you ever wondered where this celebration began? How did these traditions first start, and how have they changed over the years since their origin in ancient times? The answers may surprise you!<br/>  <br/><i>It’s Not About You Mr. Easter Bunny</i> provides an opportunity to share history, traditions and discussions in a fun way mixed with colorful illustrations perfect for young readers. It gives unique insight into this very important holiday. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Soraya Diase Coffelt, Tea Seroya
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4dc9205a